import { Pipe, PipeTransform } from '@angular/core';

declare var _: any;

@Pipe({
    name: 'blockedMaster'
})

export class BlockedMasterPipe implements PipeTransform {

    transform(array: any[], query: string): any {
        if (query) {
            if (_.filter(array, row => row.eServiceType.toLowerCase().indexOf(query.toLowerCase()) > -1) != '') {
                return _.filter(array, row => row.eServiceType.toLowerCase().indexOf(query.toLowerCase()) > -1);
            } else if (_.filter(array, row => row.blockedReason.toLowerCase().indexOf(query.toLowerCase()) > -1) != '') {
                return _.filter(array, row => row.blockedReason.toLowerCase().indexOf(query.toLowerCase()) > -1);
            } else {
                return;
            }
        }
        return array;
    }

}
